import { render, staticRenderFns } from "./insuranceLink.vue?vue&type=template&id=713383c0&scoped=true&"
import script from "./insuranceLink.vue?vue&type=script&lang=js&"
export * from "./insuranceLink.vue?vue&type=script&lang=js&"
import style0 from "./insuranceLink.vue?vue&type=style&index=0&id=713383c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713383c0",
  null
  
)

export default component.exports